import React, { useRef, useState, useEffect } from "react";
import { ZegoExpressEngine } from "zego-express-engine-webrtc";
import { GetStreamToken } from "../../services/cms.service";
import { useNavigate, useParams } from "react-router-dom";
import { SOCKET_CLIENT } from "../../../../utils/socket";
import Hls from "hls.js";
import { getLiveStreamProducts, createLeads, getSellerProfile, getStreamDetails, getStreamComments } from "../../services/stream.service";
import { getProductDetails } from "../../services/product.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS, SOCKET_EVENTS, ROLE } from "../../../../utils/Constants";
import { getUser, isUserLoggedIn, showLoginRequiredModal } from "../../../../utils/commonfunction";
import { RotateCcw, RotateCw, Volume2, VolumeX, ThumbsUp, MessageCircle, Send, MessageCircleOff, CornerDownRight, Share2 } from "lucide-react";
import { useSelector } from "react-redux";
import ShareModal from "../../components/ShareModal";
import AvatarImage from "../../components/AvatarImage";

const appID = Number(process.env.REACT_APP_ZEGO_APP_ID);
const server = process.env.REACT_APP_ZEGO_server;
/** Max rewind during live (CDN HLS sliding window; also configure Zego/CDN for ≥ this depth). */
const DVR_MAX_SECONDS = 600;
const HLS_LATENCY_FUDGE_MS = 10000;
const WEBRTC_DVR_CHUNK_MS = 5000;
const WEBRTC_CHUNK_SEC = WEBRTC_DVR_CHUNK_MS / 1000;

/** Custom Zego Live Streaming play domain: …/live/{streamID}/playlist.m3u8 */
function buildZegoCdnHlsPlaylistUrl(streamID) {
  const base = ("https://play-ws1.thela.devtechnosys.tech/live" || "").trim().replace(/\/$/, "");
  if (!base || !streamID) return "";
  return `${base}/${streamID}/playlist.m3u8`;
}

const showStreamNotification = (icon, title, text) => {
  Swal.fire({
    icon,
    title,
    text,
    toast: true,
    position: "top-end",
    timer: 3000,
    showConfirmButton: false,
    timerProgressBar: true,
    didOpen: (toast) => {
      // Force z-index above video overlay
      const container = toast.closest(".swal2-container");
      if (container) container.style.zIndex = "99999";
    },
  });
};
// const appID = 450768681;
// const server = "wss://webliveroom450768681-api.coolzcloud.com/ws";

function LiveStreamDetail({
  publisherID: propPublisherID,
  roomID: propRoomID,
  streamId: propStreamId,
  isEmbedded = false
} = {}) {
  const userData = getUser(ROLE.USER) || {};
  const hlsRef = useRef(null);
  const liveEdgeRef = useRef(0);
  const liveVideoRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [timeLeft, setTimeLeft] = useState(null);
  const [isMuted, setIsMuted] = useState(false);
  const selectedLang = useSelector((state) => state.globalData.lang);
  const captionBufferRef = useRef([]);
  const streamStartTimeRef = useRef(null);

  const [isRewinding, setIsRewinding] = useState(false);

  const navigate = useNavigate();
  const params = useParams();
  const streamId = propStreamId || params.streamId || params.id;
  const cleanStreamId = streamId?.startsWith("stream_")
    ? streamId.replace("stream_", "")
    : streamId;
  const [streamMeta, setStreamMeta] = useState(null);
  const [sellerMeta, setSellerMeta] = useState(null);

  const publisherID = propPublisherID || params.publisherID || streamMeta?.seller_id || streamMeta?.seller?._id || (typeof streamMeta?.seller === "string" ? streamMeta?.seller : undefined);
  const roomID = propRoomID || params.roomID || streamMeta?.room_id;

  const userID = userData?._id || "guest_" + Math.random().toString(36).substr(2, 9);
  const userName = userData?._id ? "viewer_" + userID : "guest_viewer_" + Math.random().toString(36).substr(2, 9);
  const publisherUserID = publisherID;
  const streamID = "stream_" + (publisherUserID || "");
  const playingStreamIDRef = React.useRef(null);
  const zegoEngineRef = useRef(null);
  const recordedVideoRef = useRef(null);
  // const liveVideoRef = useRef(null);
  const [, setEngine] = useState(null);
  const [isViewing, setIsViewing] = useState(false);
  const [liveCaption, setLiveCaption] = useState("");
  const [inputMessage, setInputMessage] = useState("");
  const [isLiked, setIsLiked] = useState(false);
  console.log(streamMeta, "streamMeta=>>>>");
  const [showShareModal, setShowShareModal] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const [showComments, setShowComments] = useState(true);
  const [dvrCurrentTime, setDvrCurrentTime] = useState(0);
  const [isPausedDVR, setIsPausedDVR] = useState(false);
  const [recordedDuration, setRecordedDuration] = useState(0);
  const [hlsWindow, setHlsWindow] = useState({ start: 0, end: 0 });
  const isRewindingRef = useRef(false);
  /** Zego WebRTC pull active (HLS unavailable or failed). */
  const webRtcPlayingRef = useRef(false);
  const hlsFallbackTimerRef = useRef(null);
  /** none | hls | webrtc — controls rewind UI */
  const [livePlaybackMode, setLivePlaybackMode] = useState("none");
  const webrtcRewindVideoRef = useRef(null);
  const rewindHlsRef = useRef(null);

  const [replyTarget, setReplyTarget] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");


  console.log(sellerMeta, "sellerMeta=>>>>001122");
  const [totalLiked, setTotalLiked] = useState(0);
  const [totalViewers, setTotalViewers] = useState(0);
  const [comments, setComments] = useState([]);
  const [pastComments, setPastComments] = useState([]);          // from DB for rewatch
  console.log(pastComments, "sdx=>>>");
  const [visiblePastComments, setVisiblePastComments] = useState([]);  // shown by video time
  console.log(visiblePastComments, "sdx=>>>1122");
  useEffect(() => {
    if (pastComments.length > 0) {
      setVisiblePastComments(pastComments);
    }
  }, [pastComments]);
  const [pastStreamStartedAt, setPastStreamStartedAt] = useState(null);
  const chatContainerRef = useRef(null);
  const [privateReplies, setPrivateReplies] = useState([]);
  const mobileScrollRef = useRef(null);
  const desktopScrollRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => {
      const elements = [mobileScrollRef.current, desktopScrollRef.current].filter(Boolean);

      for (const el of elements) {
        const rect = el.getBoundingClientRect();

        const isInside =
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom;

        if (isInside) {
          const canScroll = el.scrollWidth > el.clientWidth;
          if (!canScroll) continue;

          const atStart = el.scrollLeft <= 0;
          const atEnd = Math.ceil(el.scrollLeft + el.clientWidth) >= el.scrollWidth - 1;

          const scrollingDown = e.deltaY > 0;
          const scrollingUp = e.deltaY < 0;

          // Allow page scroll at edges
          if ((atStart && scrollingUp) || (atEnd && scrollingDown)) {
            continue;
          }

          e.preventDefault();
          el.scrollLeft += e.deltaY;
          break;
        }
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      // Use requestAnimationFrame + setTimeout(0) to ensure scroll happens after render and layout
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
          }
        }, 0);
      });
    }
  };
  const toggleMute = () => {
    const newMuteState = !isMuted;
    setIsMuted(newMuteState);

    if (liveVideoRef.current) {
      liveVideoRef.current.muted = newMuteState;
    }

    if (recordedVideoRef.current) {
      recordedVideoRef.current.muted = newMuteState;
    }
    if (webrtcRewindVideoRef.current) {
      webrtcRewindVideoRef.current.muted = newMuteState;
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [comments]);
  const fetchStreamMeta = async () => {
    try {
      const resp = await getStreamDetails(streamId);
      if (resp.success && resp.data) {
        console.log("Stream Meta Fetched:", resp.data);
        setStreamMeta(resp.data);

        // 🎯 Set seller meta from stream data
        if (resp.data.seller) {
          setSellerMeta(resp.data.seller);
        }

        // Extract like and viewer metrics
        const viewerCount = resp.data.listOfViewers?.length || 0;
        const likeCount = resp.data.listOfLikedUsers?.length || 0;
        const userLiked = Array.isArray(resp.data.listOfLikedUsers) && resp.data.listOfLikedUsers.some(
          (id) => (typeof id === "object" ? id._id || id : id)?.toString() === userID?.toString()
        );
        setTotalViewers(viewerCount);
        setTotalLiked(likeCount);
        if (userLiked) setIsLiked(true);

        // 🎯 Load historical captions
        if (resp.data.captions && resp.data.captions.length > 0) {
          console.log(`📜 Loading ${resp.data.captions.length} historical captions`);
          captionBufferRef.current = resp.data.captions.map(c => ({
            text: c.text,
            translations: c.translations,
            language: c.language,
            ts: new Date(c.timestamp).getTime()
          }));
          streamStartTimeRef.current = new Date(resp.data.captions[0].timestamp).getTime();
        } else if (resp.data.createdAt) {
          streamStartTimeRef.current = new Date(resp.data.createdAt).getTime();
        }

        // 🎯 Fetch comments for both live and rewatch
        try {
          const cResp = await getStreamComments(resp.data._id || streamId);
          console.log(cResp, "fdgdfgdfg");
          if (cResp.success && cResp.data) {
            const fetchedComments = (cResp.data.comments || []).map((c) => ({
              ...c,
              isPrivateReply: !!c.isPrivateReply,
              replyToMessage: c.replyToMessage || c.replyTo?.message || null,
            }));
            setComments(fetchedComments);
            setPastComments(fetchedComments);
            setVisiblePastComments(fetchedComments);
            if (cResp.data.streamStartedAt) {
              setPastStreamStartedAt(cResp.data.streamStartedAt);
            }
          }
        } catch (cErr) {
          console.error("Failed to fetch comments:", cErr);
        }
      }
    } catch (error) {
      console.error("Failed to fetch stream meta:", error);
    }
  };

  useEffect(() => {
    if (streamId) {
      fetchStreamMeta();
    }
  }, [streamId]);

  // Guarantee autoplay: try unmuted, fallback to muted if browser blocks audio
  useEffect(() => {
    const video = recordedVideoRef.current;
    if (video && streamMeta?.recording_url) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setIsPaused(false);
          })
          .catch((err) => {
            console.log("Autoplay unmuted blocked, falling back to muted:", err);
            if (recordedVideoRef.current) {
              recordedVideoRef.current.muted = true;
              setIsMuted(true);
              recordedVideoRef.current.play().then(() => {
                setIsPaused(false);
              }).catch(() => {});
            }
          });
      }
    }
  }, [streamMeta?.recording_url]);

  const handleLike = () => {
    if (!userData?._id) {
      Swal.fire({
        icon: "error",
        text: "Please login to like this stream",
      });
      return;
    }
    const nextLikedState = !isLiked;
    setIsLiked(nextLikedState);
    setTotalLiked((prev) => (nextLikedState ? prev + 1 : Math.max(0, prev - 1)));
    SOCKET_CLIENT.emit(SOCKET_EVENTS.LIKE_STREAM, {
      streamID: cleanStreamId,
      userId: userID,
      role: userData?.role,
      isAdvertiser: userData?.isAdvertiser,
      isLiked: nextLikedState
    });
  };

  const handleSend = () => {
    if (!userData?._id) {
      Swal.fire({
        icon: "error",
        text: "Please login to comment",
      });
      return;
    }
    if (!inputMessage.trim()) {
      return;
    }
    const msg = {
      senderID: userID,
      streamID: cleanStreamId,
      message: inputMessage.trim(),
      token: userData?.token,
    };
    SOCKET_CLIENT.emit(SOCKET_EVENTS.COMMENTED, msg);

    const optimisticMsg = {
      ...msg,
      _id: "temp_" + Date.now(),
      sender: userData,
      senderID: userID,
      senderId: userID,
      createdAt: new Date().toISOString(),
    };

    setComments((prev) => [...prev, optimisticMsg]);
    setVisiblePastComments((prev) => [...prev, optimisticMsg]);

    setInputMessage("");
  };

  const handleSendReply = () => {
    if (!userData?._id) {
      Swal.fire({
        icon: "error",
        text: "Please login to reply",
      });
      return;
    }
    if (!replyMessage.trim() || !replyTarget) return;

    const msg = {
      senderID: userID,
      streamID: cleanStreamId,
      message: replyMessage.trim(),
      replyTo: replyTarget.commentId,
      replyToCommentId: replyTarget.commentId,
      replyToMessage: replyTarget.message,
      token: userData?.token,
    };

    SOCKET_CLIENT.emit(SOCKET_EVENTS.COMMENTED, msg);

    const optimisticMsg = {
      ...msg,
      _id: "temp_" + Date.now(),
      sender: userData,
      senderID: userID,
      senderId: userID,
      createdAt: new Date().toISOString(),
    };

    setComments((prev) => [...prev, optimisticMsg]);
    setVisiblePastComments((prev) => [...prev, optimisticMsg]);

    setReplyMessage("");
    setReplyTarget(null);
  };

  // ---------------------------------------------------------
  // CDN HLS LIVE (Zego urlsHttpsHLS) + rewind within sliding window
  // ---------------------------------------------------------
  const destroyHlsPlayback = () => {
    if (hlsRef.current) {
      try {
        hlsRef.current.destroy();
      } catch (_) {
        /* noop */
      }
      hlsRef.current = null;
    }
    const v = liveVideoRef.current;
    if (v) {
      v.removeAttribute("src");
      v.srcObject = null;
      try {
        v.load();
      } catch (_) {
        /* noop */
      }
    }
    liveEdgeRef.current = 0;
    setHlsWindow({ start: 0, end: 0 });
  };

  const clearHlsFallbackTimer = () => {
    if (hlsFallbackTimerRef.current) {
      clearTimeout(hlsFallbackTimerRef.current);
      hlsFallbackTimerRef.current = null;
    }
  };

  const playWebRtc = async (zegoStreamId) => {
    clearHlsFallbackTimer();
    if (!zegoStreamId) return false;
    if (webRtcPlayingRef.current) return true;
    const zg = zegoEngineRef.current;
    if (!zg) return false;
    webRtcPlayingRef.current = true;
    try {
      if (hlsRef.current) {
        try {
          hlsRef.current.destroy();
        } catch (_) {
          /* noop */
        }
        hlsRef.current = null;
      }
      const v = liveVideoRef.current;
      if (v) {
        v.removeAttribute("src");
        v.srcObject = null;
      }
      const ms = await zg.startPlayingStream(zegoStreamId);
      playingStreamIDRef.current = zegoStreamId;
      setLivePlaybackMode("webrtc");
      if (liveVideoRef.current) {
        liveVideoRef.current.srcObject = ms;
        liveVideoRef.current.muted = isMuted;
        await liveVideoRef.current.play().catch(() => { });
      }
      if (process.env.NODE_ENV === "development") {
        console.info("[live] WebRTC started.");
      }
      return true;
    } catch (e) {
      webRtcPlayingRef.current = false;
      console.error("WebRTC play failed:", e);
      return false;
    }
  };




  const getHlsUrlFromStream = (s) =>
    (s && (s.urlsHttpsHLS || s.urlsHLS || "")) || "";

  const syncCaptionsWithPlayback = (currentTime, isDVR = false) => {
    if (!streamStartTimeRef.current) return;

    let targetTs;
    if (isDVR) {
      // In DVR, currentTime is seconds since the beginning of the RECORDED session (history + join)
      // So absolute time is streamStartTime + currentTime
      targetTs = streamStartTimeRef.current + (currentTime * 1000);
    } else {
      // For static recordings, currentTime is usually offset from start
      targetTs = streamStartTimeRef.current + (currentTime * 1000);
    }

    const list = captionBufferRef.current;
    let bestMatch = null;

    // Find the latest caption that is <= targetTs
    for (let i = 0; i < list.length; i++) {
      if (list[i].ts <= targetTs) {
        bestMatch = list[i];
      } else {
        break; // Assuming list is sorted by ts
      }
    }

    if (bestMatch) {
      const displayText = (bestMatch.language === selectedLang)
        ? bestMatch.text
        : (bestMatch.translations?.[selectedLang] || bestMatch.text);
      setLiveCaption(displayText);
    }
  };

  const syncCaptionsHls = (video) => {
    if (!video?.seekable?.length || !captionBufferRef.current.length) return;
    const end =
      liveEdgeRef.current ||
      video.seekable.end(video.seekable.length - 1);
    const behind = Math.max(0, end - video.currentTime);
    const targetTs = Date.now() - behind * 1000 - HLS_LATENCY_FUDGE_MS;
    let bestMatch = null;
    const list = captionBufferRef.current;
    for (let i = 0; i < list.length; i++) {
      if (list[i].ts <= targetTs) bestMatch = list[i];
      else break;
    }
    if (bestMatch) {
      const displayText = (bestMatch.language === selectedLang)
        ? bestMatch.text
        : (bestMatch.translations?.[selectedLang] || bestMatch.text);
      setLiveCaption(displayText);
    }
  };

  const refreshHlsWindow = () => {
    const isWtc = livePlaybackMode === "webrtc";
    const video = (isWtc && isRewinding) ? webrtcRewindVideoRef.current : liveVideoRef.current;
    const hls = isWtc ? rewindHlsRef.current : hlsRef.current;

    if (!video?.seekable?.length) return;
    let end =
      hls &&
        typeof hls.liveSyncPosition === "number" &&
        !Number.isNaN(hls.liveSyncPosition)
        ? hls.liveSyncPosition
        : video.seekable.end(video.seekable.length - 1);

    end = Math.max(end, video.currentTime);
    liveEdgeRef.current = end;
    const startAll = video.seekable.start(0);
    const earliest = Math.max(startAll, end - DVR_MAX_SECONDS);

    setHlsWindow((prev) =>
      Math.abs(prev.start - earliest) < 0.1 && Math.abs(prev.end - end) < 0.1
        ? prev
        : { start: earliest, end }
    );
  };


  const onLiveHlsTimeUpdate = () => {
    const video = liveVideoRef.current;
    if (!video) return;
    if (hlsRef.current && video.videoWidth > 0) {
      clearHlsFallbackTimer();
      setLivePlaybackMode((m) => (m === "webrtc" ? m : "hls"));
    }
    if (!hlsRef.current) return;
    refreshHlsWindow();
    setDvrCurrentTime(video.currentTime);
    syncCaptionsHls(video);
  };

  const attachHlsFromUrl = (url, zegoStreamId) => {
    if (!url || !zegoStreamId) {
      void playWebRtc(zegoStreamId || playingStreamIDRef.current);
      return;
    }
    const video = liveVideoRef.current;
    if (!video) return;
    clearHlsFallbackTimer();
    webRtcPlayingRef.current = false;
    destroyHlsPlayback();
    setLivePlaybackMode("hls");

    const scheduleBlackScreenFallback = () => {
      clearHlsFallbackTimer();
      hlsFallbackTimerRef.current = setTimeout(() => {
        hlsFallbackTimerRef.current = null;
        if (webRtcPlayingRef.current) return;
        const v = liveVideoRef.current;
        if (v && v.videoWidth < 2 && zegoEngineRef.current && zegoStreamId) {
          void playWebRtc(zegoStreamId);
        }
      }, 6500);
    };

    const tryWebRtcOnManifestFail = (data) => {
      const d = data?.details || "";
      if (
        d === "manifestLoadError" ||
        d === "manifestParsingError" ||
        d === "levelEmptyError"
      ) {
        clearHlsFallbackTimer();
        try {
          hlsRef.current?.destroy();
        } catch (_) {
          /* noop */
        }
        hlsRef.current = null;
        void playWebRtc(zegoStreamId);
        return true;
      }
      return false;
    };

    if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        maxBufferLength: 120,
        liveBackBufferLength: DVR_MAX_SECONDS + 90,
      });
      hlsRef.current = hls;
      hls.on(Hls.Events.ERROR, (_, data) => {
        if (!data.fatal) return;
        if (tryWebRtcOnManifestFail(data)) return;
        if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
          hls.startLoad();
        } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
          hls.recoverMediaError();
        } else {
          console.error("HLS fatal error", data);
          void playWebRtc(zegoStreamId);
        }
      });
      hls.on(Hls.Events.MANIFEST_PARSED, () => scheduleBlackScreenFallback());
      hls.loadSource(url);
      hls.attachMedia(video);
      scheduleBlackScreenFallback();
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      const onNativeErr = () => {
        video.removeEventListener("error", onNativeErr);
        void playWebRtc(zegoStreamId);
      };
      video.addEventListener("error", onNativeErr);
      video.src = url;
      scheduleBlackScreenFallback();
    } else {
      void playWebRtc(zegoStreamId);
      return;
    }
    video.muted = isMuted;
    video.play().catch(() => { });
  };

  const beginLivePlayback = async (targetStream) => {
    const sid =
      targetStream?.streamID ||
      (cleanStreamId ? `stream_${cleanStreamId}` : "");
    if (!sid) return false;
    playingStreamIDRef.current = sid;
    setIsViewing(true);

    // Prioritize WebRTC for fast startup
    const success = await playWebRtc(sid);
    if (!success) {
      // Fallback to HLS only if WebRTC fails
      const fromSdk = getHlsUrlFromStream(targetStream);
      const cdnUrl = buildZegoCdnHlsPlaylistUrl(sid);
      const url = fromSdk || cdnUrl;
      if (url) {
        attachHlsFromUrl(url, sid);
      }
    }
    return true;
  };


  const initRewindHls = async () => {
    const sid = playingStreamIDRef.current;
    if (!sid) return;
    const hlsUrl = buildZegoCdnHlsPlaylistUrl(sid);
    if (!hlsUrl) return;

    if (Hls.isSupported()) {
      if (rewindHlsRef.current) rewindHlsRef.current.destroy();
      const hls = new Hls();
      rewindHlsRef.current = hls;
      hls.loadSource(hlsUrl);
      hls.attachMedia(webrtcRewindVideoRef.current);
      return new Promise((resolve) => {
        hls.on(Hls.Events.MANIFEST_PARSED, resolve);
      });
    } else if (webrtcRewindVideoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      webrtcRewindVideoRef.current.src = hlsUrl;
    }
  };

  const clearWebRtcRewindPlayer = () => {
    if (rewindHlsRef.current) {
      rewindHlsRef.current.destroy();
      rewindHlsRef.current = null;
    }
    const v = webrtcRewindVideoRef.current;
    if (v) {
      try {
        v.pause();
        v.removeAttribute("src");
        v.load();
      } catch (_) {
        /* noop */
      }
    }
  };

  const rewindLast10 = () => {
    if (livePlaybackMode === "webrtc") {
      void (async () => {
        try {
          if (!rewindHlsRef.current) {
            await initRewindHls();
          }
          const rv = webrtcRewindVideoRef.current;
          if (rv) {
            rv.muted = isMuted;
            if (rv.seekable.length > 0) {
              const end = rv.seekable.end(rv.seekable.length - 1);
              rv.currentTime = Math.max(0, end - 10);
            } else {
              rv.currentTime = Math.max(0, rv.currentTime - 10);
            }
            await rv.play().catch(() => { });
          }
          setIsRewinding(true);
          isRewindingRef.current = true;
        } catch (_) {
          /* noop */
        }
      })();
      return;
    }


    const v = liveVideoRef.current;
    if (!v?.seekable?.length) return;

    refreshHlsWindow();

    const end = liveEdgeRef.current || v.seekable.end(v.seekable.length - 1);
    const earliest = Math.max(v.seekable.start(0), end - DVR_MAX_SECONDS);

    const newTime = Math.max(earliest, v.currentTime - 10);

    v.currentTime = newTime;
    v.play().catch(() => { });

    isRewindingRef.current = true;
    setIsRewinding(true);
  };

  const resumeLive = () => {
    if (livePlaybackMode === "webrtc") {
      clearWebRtcRewindPlayer();
      setIsRewinding(false);
      isRewindingRef.current = false;
      setIsPausedDVR(false);
      liveVideoRef.current?.play().catch(() => { });
      return;
    }


    const v = liveVideoRef.current;
    if (!v?.seekable?.length) return;

    refreshHlsWindow();

    const end = liveEdgeRef.current || v.seekable.end(v.seekable.length - 1);

    v.currentTime = end - 1;
    v.play().catch(() => { });

    setIsRewinding(false);
    isRewindingRef.current = false;
    setIsPausedDVR(false);
  };

  const handleSeek = (e) => {
    const t = parseFloat(e.target.value);
    if (livePlaybackMode === "webrtc") {
      void (async () => {
        try {
          if (!rewindHlsRef.current) await initRewindHls();
          const rv = webrtcRewindVideoRef.current;
          if (!rv || isNaN(t)) return;

          const end = rv.seekable.length > 0 ? rv.seekable.end(rv.seekable.length - 1) : 0;
          if (t >= end - 2) {
            clearWebRtcRewindPlayer();
            setIsRewinding(false);
            isRewindingRef.current = false;
            liveVideoRef.current?.play().catch(() => { });
            return;
          }

          rv.currentTime = t;
          await rv.play().catch(() => { });
          setDvrCurrentTime(t);
          setIsRewinding(true);
          isRewindingRef.current = true;
        } catch (_) {
          /* noop */
        }
      })();
      return;
    }


    const v = liveVideoRef.current;

    if (!v || !v.seekable?.length || isNaN(t)) return;

    refreshHlsWindow();

    const end = liveEdgeRef.current || t;
    const nearLive = t >= end - 3;

    v.currentTime = t;
    v.play().catch(() => { });

    setDvrCurrentTime(t);
    setIsRewinding(!nearLive);
    isRewindingRef.current = !nearLive;
  };
  const togglePlayPauseDVR = () => {
    const v =
      webRtcPlayingRef.current && isRewinding
        ? webrtcRewindVideoRef.current
        : liveVideoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play().catch((err) => {
        if (err.name !== "AbortError") console.error(err);
      });
      setIsPausedDVR(false);
    } else {
      v.pause();
      setIsPausedDVR(true);
    }
  };

  const startViewing = async () => {
    try {
      console.log("🎬 Starting CDN HLS viewer for Room:", roomID);
      const zg = new ZegoExpressEngine(appID, server);
      zegoEngineRef.current = zg;
      setEngine(zg);

      const res = await GetStreamToken(userID, roomID);
      const token = res.token;

      zg.on("roomStreamUpdate", async (_rid, updateType, streamList) => {
        try {
          if (updateType === "ADD" && streamList.length > 0) {
            const targetStream = streamList[0];
            console.log("🎥 Stream ADD:", targetStream.streamID);
            void beginLivePlayback(targetStream);
          }
          if (updateType === "DELETE") {
            clearHlsFallbackTimer();
            if (webRtcPlayingRef.current && zegoEngineRef.current && playingStreamIDRef.current) {
              try {
                zegoEngineRef.current.stopPlayingStream(playingStreamIDRef.current);
              } catch (_) {
                /* noop */
              }
              webRtcPlayingRef.current = false;
            }
            destroyHlsPlayback();
            Swal.fire({
              icon: "info",
              title: "Stream Ended",
              text: "Stream ended by publisher.",
              allowOutsideClick: false,
              confirmButtonText: "OK",
              confirmButtonColor: "#403fad",
            }).then(() => {
              stopViewing();
              navigate("/user/live-streams");
            });
          }
        } catch (err) {
          console.error("Stream update error:", err);
        }
      });

      await zg.loginRoom(roomID, token, { userID, userName });

      let existingStreams = [];
      try {
        if (typeof zg.getRoomStreamList === "function") {
          existingStreams = await zg.getRoomStreamList(roomID);
        }
      } catch (e) {
        console.warn("getRoomStreamList:", e);
      }
      if (existingStreams.length > 0) {
        void beginLivePlayback(existingStreams[0]);
      }

      setTimeout(async () => {
        if (hlsRef.current || webRtcPlayingRef.current) return;
        try {
          if (typeof zg.getRoomStreamList === "function") {
            const list = await zg.getRoomStreamList(roomID);
            if (list?.length) void beginLivePlayback(list[0]);
          }
        } catch (_) {
          /* noop */
        }
        if (!hlsRef.current && !webRtcPlayingRef.current && cleanStreamId) {
          void beginLivePlayback({ streamID: `stream_${cleanStreamId}` });
        }
      }, 2500);
    } catch (err) {
      console.error("❌ Viewer Error:", err);
    }
  };

  const stopViewing = async () => {
    try {
      clearHlsFallbackTimer();
      const zg = zegoEngineRef.current;
      const sid = playingStreamIDRef.current;
      // stopWebRtcDvrRecorder();
      // webrtcDvrChunksRef.current = [];
      // setWebrtcBufferSec(0);
      clearWebRtcRewindPlayer();
      if (webRtcPlayingRef.current && zg && sid) {
        try {
          await zg.stopPlayingStream(sid);
        } catch (_) {
          /* noop */
        }
        webRtcPlayingRef.current = false;
      }
      destroyHlsPlayback();
      if (liveVideoRef.current) {
        liveVideoRef.current.srcObject = null;
      }
      if (zg) {
        try {
          await zg.logoutRoom(roomID);
        } catch (_) {
          /* noop */
        }
        try {
          zg.destroyEngine();
        } catch (_) {
          /* noop */
        }
        zegoEngineRef.current = null;
        setEngine(null);
      }
      setIsViewing(false);
      setLivePlaybackMode("none");
      isRewindingRef.current = false;
      setIsRewinding(false);
    } catch (err) {
      console.error("❌ Stop Error:", err);
    }
  };

  useEffect(() => {
    if (!cleanStreamId) return;

    console.log("🔌 Joining caption room:", cleanStreamId);

    const joinRooms = () => {
      SOCKET_CLIENT.emit("join_stream_room", cleanStreamId);
      if (userID) {
        SOCKET_CLIENT.emit("join_stream_room", userID);
      }
      // Emit JOIN_STREAM to correctly track active viewer counts on backend
      SOCKET_CLIENT.emit(SOCKET_EVENTS.JOIN_STREAM, {
        streamID: cleanStreamId,
        userId: userID,
        role: "viewer",
      });
    };

    if (SOCKET_CLIENT.connected) {
      joinRooms();
    }
    SOCKET_CLIENT.on("connect", joinRooms);

    const handleGetData = (payload) => {
      console.log("📨 GET-DATA received:", payload);
      if (payload?.event === "NEW_LEAD") {
        showStreamNotification("success", "New Lead! 🎉", payload?.message || "A new lead was created.");
      }
    };

    const handleSafetyFlag = (payload) => {
      console.log("⚠️ Safety flag received:", payload);
      showStreamNotification("warning", "Safety Flag ⚠️", "A product was flagged for safety issues.");
    };

    const handleCaption = (data) => {
      console.log("📥 Received socket caption:", data);

      if (data?.transcript) {
        // Broadcaster sent a full caption object with translations
        const displayText = (data.language === selectedLang)
          ? data.transcript
          : (data.translations?.[selectedLang] || data.transcript);

        if (!isRewinding) {
          setLiveCaption(displayText);
        }

        const now = Date.now();
        if (!streamStartTimeRef.current) {
          streamStartTimeRef.current = now;
        }

        captionBufferRef.current.push({
          text: data.transcript,
          translations: data.translations,
          language: data.language,
          ts: now,
        });

        const oneHour = 3600000;
        captionBufferRef.current =
          captionBufferRef.current.filter((c) => now - c.ts < oneHour);
      }
    };

    SOCKET_CLIENT.on("GET-DATA", handleGetData);
    SOCKET_CLIENT.on("SAFETY_FLAG_DETECTED", handleSafetyFlag);
    SOCKET_CLIENT.on("live_caption", handleCaption);

    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_VIEWER_COUNT, (data) => {
      console.log("STREAM_VIEWER_COUNT received in user Detail:", data);
      if (data?.totalLikes !== undefined) setTotalLiked(data.totalLikes);
      const viewsCount = data?.totalDbViews !== undefined ? data.totalDbViews : (data?.totalViews !== undefined ? data.totalViews : data?.totalViewers);
      if (viewsCount !== undefined) setTotalViewers(viewsCount);
      if (data?.userId?.toString() === userID?.toString() && data?.isLiked !== undefined) {
        setIsLiked(data.isLiked);
      }
    });

    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_LIKE_UPDATE, (data) => {
      if (data?.totalLikes !== undefined) setTotalLiked(data.totalLikes);
      if (data?.userId?.toString() === userID?.toString() && data?.isLiked !== undefined) {
        setIsLiked(data.isLiked);
      }
    });

    SOCKET_CLIENT.on(SOCKET_EVENTS.NEW_COMMENT, (data) => {
      console.log("💬 New comment received:", data);
      const newComment = {
        ...data,
        isPrivateReply: !!data.isPrivateReply,
        replyToMessage: data.replyToMessage || data.replyTo?.message || null,
      };

      const updateList = (prev) => {
        if (data._id && prev.some((c) => c._id === data._id)) return prev;
        const tempIdx = prev.findIndex(
          (c) =>
            c._id?.toString().startsWith("temp_") &&
            (c.senderID?.toString() === data.sender?._id?.toString() ||
             c.senderId?.toString() === data.sender?._id?.toString() ||
             c.sender?._id?.toString() === data.sender?._id?.toString()) &&
            c.message === data.message
        );
        if (tempIdx !== -1) {
          const next = [...prev];
          next[tempIdx] = newComment;
          return next;
        }
        return [...prev, newComment];
      };

      setComments(updateList);
      setVisiblePastComments(updateList);
    });

    SOCKET_CLIENT.on(SOCKET_EVENTS.PRIVATE_REPLY, (data) => {
      console.log("🤫 Private reply received:", data);
      const isTarget = data.targetUserID?.toString() === userID?.toString();
      const isSender = data.senderID?.toString() === userID?.toString() || data.sender?._id?.toString() === userID?.toString();

      if (!isTarget && !isSender) return;

      setPrivateReplies((prev) => {
        const exists = prev.some(r => r._id === data._id);
        if (exists) return prev;
        return [...prev, {
          ...data,
          isPrivateReply: true,
          replyToMessage: data.replyToMessage || data.replyTo?.message || null
        }];
      });
    });
    SOCKET_CLIENT.on(SOCKET_EVENTS.NEW_PRODUCT, (data) => {
      console.log("🎁 New product received via socket:", data);
      if (data && data.product && data.product.verified_by_staff === true) {
        setProducts((prev) => {
          // Check if product already exists to avoid duplicates
          const exists = prev.some(p => p._id === data.product._id);
          if (exists) return prev;
          return [data.product, ...prev];
        });
      }
    });

    SOCKET_CLIENT.on(SOCKET_EVENTS.PRODUCT_REMOVED, (data) => {
      console.log("🚫 Product removed via socket:", data);
      if (data && data.productID) {
        setProducts((prev) => prev.filter(p => p._id !== data.productID));
      }
    });

    return () => {
      SOCKET_CLIENT.emit(SOCKET_EVENTS.LEAVE_STREAM, {
        streamID: cleanStreamId,
        userId: userID,
        role: "viewer",
      });
      SOCKET_CLIENT.off("connect", joinRooms);
      SOCKET_CLIENT.off("GET-DATA", handleGetData);
      SOCKET_CLIENT.off("SAFETY_FLAG_DETECTED", handleSafetyFlag);
      SOCKET_CLIENT.off("live_caption", handleCaption);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_VIEWER_COUNT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_LIKE_UPDATE);
      SOCKET_CLIENT.off(SOCKET_EVENTS.NEW_COMMENT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.NEW_PRODUCT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.PRIVATE_REPLY);
    };
  }, [streamId]);

  const fetchProducts = async () => {
    try {
      const resp = await getLiveStreamProducts({ stream_id: streamId });
      if (resp.success) {
        // Only show products that have been accepted/verified by staff
        const verified = (resp.data || []).filter(p => p.verified_by_staff === true);
        setProducts(verified);
      }
    } catch (error) {
      console.error("❌ Error fetching live products:", error);
    }
  };
  const totalDurationSeconds = streamMeta?.duration
    ? streamMeta.duration * 60
    : 0;
  useEffect(() => {
    if (!streamMeta) return;

    // Only start WebRTC for real live streams
    if (streamMeta.stream_type === "live" && streamMeta.isLive === true) {
      startViewing();
      fetchProducts();
    } else {
      stopViewing();
    }

    return () => {
      stopViewing();
    };
  }, [streamMeta]);

  const handleCreateLead = (productId) => {
    const targetUrl = `/user/product-details?o_id=${productId}`;
    if (!isUserLoggedIn()) {
      showLoginRequiredModal({
        navigate,
        redirectUrl: targetUrl,
      });
      return;
    }
    navigate(targetUrl);
  };
  useEffect(() => {
    fetchProducts();
  }, [streamId]);
  useEffect(() => {
    if (!streamMeta) return;

    // Only run counter for LIVE streams
    if (streamMeta.isLive) {
      const start = streamMeta.streamStartedAt ? new Date(streamMeta.streamStartedAt).getTime() : null;

      if (!start) {
        setTimeLeft(0);
        return;
      }

      const interval = setInterval(() => {
        // 🎯 Add 5s latency offset to synchronize timer with stream arrival
        const LATENCY_OFFSET_MS = 5000;
        const elapsed = Math.floor((Date.now() - (start + LATENCY_OFFSET_MS)) / 1000);

        // 🎯 Hard-Sync recordedDuration and timeLeft
        // If recordedDuration is larger (from chunks), use it. 
        // Otherwise use wall-clock elapsed.
        const accurateDuration = Math.max(elapsed, Math.floor(recordedDuration));

        setTimeLeft(accurateDuration);
        setRecordedDuration(accurateDuration);
      }, 1000);

      return () => clearInterval(interval);
    } else {
      // For rewatch/past streams, set initial total duration
      setTimeLeft(totalDurationSeconds);
    }
  }, [streamMeta, totalDurationSeconds]);
  const formatTime = (seconds) => {
    if (isNaN(seconds) || seconds === undefined || seconds === null) return "00:00";
    const totalSeconds = Math.floor(seconds);
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const handlePlayPause = () => {
    const video = recordedVideoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play().catch((err) => { if (err.name !== "AbortError") console.error(err); });
    } else {
      video.pause();
    }
  };

  const forward10 = () => {
    const video = recordedVideoRef.current;
    if (!video) return;

    video.currentTime += 10;
  };

  const backward10 = () => {
    const video = recordedVideoRef.current;
    if (!video) return;

    video.currentTime -= 10;
  };
  const truncateWords = (text, limit = 5) => {
    if (!text || typeof text !== "string") return "";
    console.log(text, "text");
    const words = text.trim().split(/\s+/);
    return words.length > limit ? words.slice(0, limit).join(" ") + "..." : text;
  };
  const isMobile = window.innerWidth <= 768;

  if (isEmbedded && streamMeta && !streamMeta?.isLive && !streamMeta?.recording_url) {
    return null;
  }

  return (
    <div className={isEmbedded ? "live-stream-detail w-full" : "live-stream-detail py-10 pt-3"}>
      <div className={isEmbedded ? "w-full" : "container mx-auto px-4"}>
        <div className={`relative z-10 w-full rounded-[20px] overflow-hidden aspect-[9/16] md:aspect-auto min-h-[220px] md:min-h-[500px] bg-black ${isEmbedded ? "h-[450px] md:h-[550px] lg:h-[calc(100vh-140px)]" : "lg:h-[calc(100vh-120px)]"} flex items-center justify-center`}>

          {/* 🎥 SCENARIO 1 — LIVE (CDN HLS + up to 10 min rewind) */}
          {streamMeta?.stream_type === "live" && streamMeta?.isLive === true && (
            <>
              <video
                ref={liveVideoRef}
                autoPlay
                playsInline
                muted={isMuted}
                onTimeUpdate={onLiveHlsTimeUpdate}
                onPlay={() => setIsPausedDVR(false)}
                onPause={() => setIsPausedDVR(true)}
                className={`w-full h-full object-cover bg-black ${livePlaybackMode === "webrtc" && isRewinding ? "hidden" : ""
                  }`}
              />
              <video
                ref={webrtcRewindVideoRef}
                playsInline
                muted={isMuted}
                onTimeUpdate={(e) => {
                  setDvrCurrentTime(e.target.currentTime);
                  syncCaptionsWithPlayback(e.target.currentTime, true);
                  refreshHlsWindow();
                }}
                onPlay={() => setIsPausedDVR(false)}
                onPause={() => setIsPausedDVR(true)}
                className={`w-full h-full object-cover bg-black ${livePlaybackMode === "webrtc" && isRewinding ? "" : "hidden"
                  }`}
              />

            </>
          )}

          {/* 🎥 SCENARIO 2 — FEATURE LIVE (Recorded playing as Live) */}
          {streamMeta?.stream_type === "recorded" && streamMeta?.isLive === true && streamMeta?.recording_url && (
            <video
              src={streamMeta.recording_url}
              autoPlay
              playsInline
              muted={isMuted}
              onTimeUpdate={(e) => syncCaptionsWithPlayback(e.target.currentTime, false)}
              controls
              className="w-full h-full object-cover bg-black"
            />
          )}

          {/* 🎥 SCENARIO 3 — REWATCH (Past Stream) */}
          {streamMeta?.isLive === false && streamMeta?.recording_url && (
            <>

              <video
                ref={recordedVideoRef}
                src={streamMeta.recording_url}
                controls
                autoPlay
                onPlay={() => setIsPaused(false)}
                onPause={() => setIsPaused(true)}
                playsInline
                muted={isMuted}
                onTimeUpdate={(e) => {
                  setTimeLeft(Math.floor(e.target.currentTime));
                  syncCaptionsWithPlayback(e.target.currentTime, false);
                }}
                className="w-full h-full object-contain bg-black"
              />

              <div className={`absolute top-1/2 -translate-y-1/2 flex items-center pointer-events-none z-[130] transition-all duration-500 ease-in-out
                               ${showComments
                  ? "lg:left-0 lg:right-[400px] left-0 right-0 justify-between px-10 lg:justify-center lg:gap-24"
                  : "inset-x-0 justify-between px-10"
                }`}>
                {/* 10s Backward */}
                <button
                  onClick={backward10}
                  className="pointer-events-auto w-[60px] h-[60px] rounded-full 
                             bg-black/20 backdrop-blur-md border border-white/10
                             flex flex-col items-center justify-center 
                             text-white transition-all duration-300
                             hover:bg-black/40 hover:scale-110 active:scale-95 shadow-xl group"
                >
                  <RotateCcw size={22} className="group-hover:-rotate-12 transition-transform" />
                  <span className="text-[9px] font-bold mt-1 uppercase tracking-wider opacity-80">10s</span>
                </button>

                {/* 10s Forward */}
                <button
                  onClick={forward10}
                  className="pointer-events-auto w-[60px] h-[60px] rounded-full 
                             bg-black/20 backdrop-blur-md border border-white/10
                             flex flex-col items-center justify-center 
                             text-white transition-all duration-300
                             hover:bg-black/40 hover:scale-110 active:scale-95 shadow-xl group"
                >
                  <RotateCw size={22} className="group-hover:rotate-12 transition-transform" />
                  <span className="text-[9px] font-bold mt-1 uppercase tracking-wider opacity-80">10s</span>
                </button>
              </div>
            </>
          )}
          {/* THUMBNAIL */}
          {streamMeta?.isLive === false && !streamMeta?.recording_url && (
            <img
              src={streamMeta?.thumbnail || "/images/video.png"}
              alt="thumbnail"
              className="w-full h-full object-cover"
            />
          )}

          {/* Unified DVR Control Bar (Live only) */}
          {/* {streamMeta?.stream_type === "live" && streamMeta?.isLive === true && (
            <div className="absolute inset-x-0 bottom-0 z-[110] px-4 pb-14 lg:pb-6 pt-10 bg-gradient-to-t from-black/90 via-black/40 to-transparent pointer-events-none">
              <div className="max-w-screen-md mx-auto flex flex-col gap-4 pointer-events-auto">


                <div className="group relative w-full flex flex-col justify-center">
                  <div className="flex justify-between items-center mb-1 drop-shadow-md">
                    <span className="text-[10px] font-bold text-white/90 uppercase tracking-widest bg-black/40 px-2 py-0.5 rounded">
                      {isRewinding ? "Rewind Mode" : "Live Stream"}
                    </span>
                    <span className="text-[10px] font-bold text-white/90 tabular-nums bg-black/40 px-2 py-0.5 rounded">
                      {(() => {
                        const span = Math.max(0, hlsWindow.end - hlsWindow.start);
                        const pos = Math.max(0, dvrCurrentTime - hlsWindow.start);
                        if (!isRewinding && livePlaybackMode === "webrtc") return "LIVE";
                        return `${formatTime(pos)} / ${formatTime(Math.min(span, DVR_MAX_SECONDS) || 0)}`;
                      })()}
                    </span>
                  </div>
                  <input
                    type="range"
                    min={hlsWindow.start}
                    max={hlsWindow.end || 0.1}
                    step="0.1"
                    value={isRewinding ? dvrCurrentTime : hlsWindow.end}
                    onChange={handleSeek}
                    disabled={!(hlsWindow.end > hlsWindow.start)}
                    className="w-full h-1.5 bg-white/30 rounded-lg appearance-none cursor-pointer accent-red-600 transition-all hover:h-2 disabled:opacity-40"
                  />
                </div>


                <div className="flex items-center justify-between text-white pb-2 mb-40 pointer-events-auto">
                  <div className="flex items-center gap-6">


                    {isRewinding && (
                      <button onClick={togglePlayPauseDVR} className="hover:scale-110 transition-transform bg-white/10 p-2 rounded-full">
                        {isPausedDVR ? (
                          <img src="/images/playButton.svg" alt="Play" className="w-5 h-5" />
                        ) : (
                          <div className="w-5 h-5 flex items-center justify-center gap-1">
                            <div className="w-1 h-4 bg-white rounded-full"></div>
                            <div className="w-1 h-4 bg-white rounded-full"></div>
                          </div>
                        )}
                      </button>
                    )}

                    <div className="flex items-center gap-4">
                      <button onClick={rewindLast10} className="w-10 h-10 flex items-center justify-center hover:bg-white/10 rounded-full transition-colors border border-white/10" title="Back 10s">
                        <RotateCcw size={18} />
                      </button>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">

                    <button
                      onClick={resumeLive}
                      className={`flex items-center gap-2 px-4 py-1.5 rounded-full font-black text-[11px] tracking-wider transition-all ${isRewinding
                        ? 'bg-white/10 text-white/60 hover:text-white hover:bg-white/20'
                        : 'bg-red-600 text-white animate-pulse shadow-[0_0_20px_rgba(220,38,38,0.6)]'
                        }`}
                    >
                      <span className={`w-2 h-2 rounded-full ${isRewinding ? 'bg-white/40' : 'bg-white'}`}></span>
                      LIVE
                    </button>
                  </div>
                </div>

              </div>
            </div>
          )} */}

          {/* Overlay UI */}
          <div className="absolute inset-0 flex p-[15px] gap-[30px] z-[120] pointer-events-none">
            <div className="!absolute !top-0 !left-0 !w-full !h-[120px] !bg-gradient-to-t !from-transparent !via-black/20 !to-black/60 -z-1"></div>

            {/* Leave stream / Leave (0px–1024px only) */}
            <div className="block lg:hidden absolute top-4 right-4 z-30 pointer-events-auto">
              <button
                onClick={() => {
                  stopViewing();
                  navigate("/user/live-streams");
                }}
                className="bg-red-500 hover:bg-red-600 text-white text-xs md:text-sm font-semibold px-4 py-2 rounded-full shadow-lg"
              >
                Leave Stream
              </button>
            </div>

            {/* MOBILE HEADER (profile + timer + live/views) */}
            <div className="lg:hidden absolute top-4 left-4 right-4 flex flex-col gap-2 z-20 pointer-events-none">
              {/* Profile row */}
              <div className="flex items-center justify-between pointer-events-auto">
                <div className="flex items-center gap-2">
                  <img
                    src={sellerMeta?.profile_image || sellerMeta?.store_image || "/images/User.png"}
                    onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                    alt="User"
                    className="w-8 h-8 rounded-full object-cover border border-white/30"
                  />
                  <div className="flex flex-col">
                    <span className="text-white text-sm font-semibold leading-tight">
                      {sellerMeta?.name || "Sarah Miller"}
                    </span>
                    <span className="text-white/70 text-[11px] leading-tight">
                      {sellerMeta?.store_name || "Sarah's Boutique"}
                    </span>
                  </div>
                </div>

                {/* Time pill */}
                {streamMeta?.duration && timeLeft !== null && (
                  <span className="bg-pink-500 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-md">
                    {formatTime(timeLeft)}
                  </span>
                )}
              </div>

              {/* Live + views row */}
              <div className="flex items-center gap-2 pointer-events-auto">
                {streamMeta?.isLive && (
                  <span className="bg-red-600 text-white text-[11px] px-2.5 py-1 rounded-full">
                    Live
                  </span>
                )}
                <span className="bg-white text-black text-[11px] px-2.5 py-1 rounded-full flex items-center gap-1">
                  <img src="/images/eye5.svg" alt="eye" className="w-3.5 h-3.5" />
                  <span>{totalViewers} views</span>
                </span>
                {/* Like count */}
                <span className="bg-white text-black text-[11px] px-2.5 py-1 rounded-full flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[14px] h-[14px]"><path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"></path></svg> <span>{totalLiked} Likes</span>
                </span>
              </div>
            </div>

            {/* Center Play/Pause Button (Scenario 3) */}
            {streamMeta?.isLive === false && streamMeta?.recording_url && isPaused && (
              <div className="absolute inset-0 flex items-center justify-center">
                <button
                  onClick={handlePlayPause}
                  className="pointer-events-auto transition-transform hover:scale-110 active:scale-95 z-50"
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src="/images/playButton.svg"
                    alt="Play"
                    className="w-[60px] h-[60px] md:w-[80px] md:h-[80px] drop-shadow-lg"
                  />
                </button>
              </div>
            )}

            {/* Bottom Action Bar (Circular Buttons) */}
            {/* Desktop: centered group (like / comment / mic / share) */}
            <div className={`hidden lg:flex absolute inset-x-0 ${streamMeta?.isLive === false || streamMeta?.stream_type === "recorded" ? "bottom-40" : "bottom-36"} justify-center items-center pointer-events-none z-[130]`}>
              <div className="flex items-center gap-4 pointer-events-auto">
                {/* Like Button */}
                <button
                  onClick={handleLike}
                  className={`w-[50px] h-[50px] rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 active:scale-95 ${isLiked ? "bg-red-500 text-white" : "bg-white/10 backdrop-blur-md border border-white/20 text-white"
                    }`}
                >
                  <ThumbsUp size={22} fill={isLiked ? "white" : "none"} />
                </button>

                {/* Comments Toggle Button */}
                <button
                  onClick={() => setShowComments(!showComments)}
                  className="w-[50px] h-[50px] rounded-full backdrop-blur-md flex items-center justify-center shadow-lg border border-white/20 hover:bg-black/60 transition-all hover:scale-110 active:scale-95"
                >
                  {showComments ? <MessageCircleOff size={22} className="text-white" /> : <MessageCircle size={22} className="text-white" />}
                </button>

                {/* Mic Mute Toggle */}
                <button
                  onClick={toggleMute}
                  className="w-[50px] h-[50px] rounded-full backdrop-blur-md flex items-center justify-center shadow-lg border border-white/20 hover:bg-black/60 transition-all hover:scale-110 active:scale-95"
                >
                  {isMuted ? (
                    <VolumeX size={22} className="text-white" />
                  ) : (
                    <Volume2 size={22} className="text-white" />
                  )}
                </button>

                {/* Share Stream Button */}
                <button
                  onClick={() => setShowShareModal(true)}
                  className="w-[50px] h-[50px] rounded-full backdrop-blur-md flex items-center justify-center shadow-lg border border-white/20 hover:bg-black/60 transition-all hover:scale-110 active:scale-95 text-white"
                  title="Share Live Stream"
                >
                  <Share2 size={22} className="text-white" />
                </button>
              </div>
            </div>

            {/* Mobile: vertical stack on right, like screenshot */}
            <div className={`lg:hidden absolute right-4 ${streamMeta?.isLive === false || streamMeta?.stream_type === "recorded" ? "bottom-44" : "bottom-40"} flex flex-col items-center gap-2 z-[130] pointer-events-auto`}>
              {/* Like Button */}
              <button
                onClick={handleLike}
                className={`w-[44px] h-[44px] rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 active:scale-95 ${isLiked ? "bg-red-500 text-white" : "bg-white text-red-500"
                  }`}
              >
                <ThumbsUp size={26} fill={isLiked ? "white" : "none"} />
              </button>

              {/* Comments Toggle Button */}
              <button
                onClick={() => setShowComments(!showComments)}
                className="w-[44px] h-[44px] rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center shadow-lg border border-white/40 hover:bg-black/40 transition-all hover:scale-110 active:scale-95"
              >
                {showComments ? <MessageCircleOff size={22} className="text-white" /> : <MessageCircle size={22} className="text-white" />}
              </button>

              {/* Mic Mute Toggle */}
              <button
                onClick={toggleMute}
                className="w-[44px] h-[44px] rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center shadow-lg border border-white/40 hover:bg-black/40 transition-all hover:scale-110 active:scale-95"
              >
                {isMuted ? (
                  <VolumeX size={22} className="text-white" />
                ) : (
                  <Volume2 size={22} className="text-white" />
                )}
              </button>

              {/* Share Stream Button */}
              <button
                onClick={() => setShowShareModal(true)}
                className="w-[44px] h-[44px] rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center shadow-lg border border-white/40 hover:bg-black/40 transition-all hover:scale-110 active:scale-95 text-white"
                title="Share Live Stream"
              >
                <Share2 size={22} className="text-white" />
              </button>
            </div>

            {/* LEFT SIDE PANEL (desktop only) */}
            <div className={`flex-1 flex md:hidden lg:flex flex-col justify-between pointer-events-none h-[100%] ${showComments ? "w-[calc(100%-400px)]" : "w-full"} relative`}>
              {/* Live info */}
              <div className="flex items-center gap-3 justify-between hidden lg:flex pointer-events-auto">
                <div className="flex items-center gap-2">
                  {streamMeta?.isLive && (
                    <span className="bg-red-600 text-white text-[16px] px-3 py-1 rounded-full">Live</span>
                  )}
                  <span className="bg-white text-black text-[16px] px-2 py-[5px] rounded-full flex items-center gap-1">
                    <img src="/images/eye5.svg" alt="eye" /> {totalViewers} views
                  </span>
                  <span className="bg-white text-black text-[16px] px-3 py-[5px] rounded-full flex items-center gap-2 font-semibold">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-[18px] h-[18px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                    </svg>
                    {totalLiked} likes
                  </span>
                </div>
                {streamMeta?.duration && timeLeft !== null && (
                  <span
                    className={`bg-pink-500 text-white text-sm font-semibold px-3 py-1.5 rounded-full transition-all duration-200`}
                  >
                    {formatTime(timeLeft)}
                  </span>
                )}
              </div>

              {/* Products (Horizontal Scroll) */}
              {/* Desktop carousel */}
              {products && products.length > 0 && (
                <div
                  ref={desktopScrollRef}
                  className={`hidden lg:flex ${showComments ? "w-full ml-2" : "w-full px-4"} ${streamMeta?.isLive === false || streamMeta?.stream_type === "recorded" ? "mb-16" : "mb-0"} flex-row flex-nowrap gap-4 overflow-x-auto pb-0 custom-scrollbar pointer-events-none`}
                  style={{ scrollSnapType: 'x mandatory' }}
                >
                  {products.map((item) => (
                    <div
                      key={item._id}
                      className="bg-white rounded-[10px] p-[10px] min-w-[200px] md:min-w-[240px] max-w-[350px] shadow-md flex items-center gap-3 flex-shrink-0 pointer-events-auto"
                      style={{ scrollSnapAlign: 'start' }}
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-[70px] h-[70px] object-cover rounded-[10px] flex-shrink-0"
                      />

                      <div className="flex-1 min-w-0 w-[120px]">
                        <h5 className="text-zinc-950 font-bold text-sm truncate">
                          {item?.title}
                        </h5>

                        <p className="text-zinc-950 font-bold text-xs">
                          {item.price ? "INR " + item.price : "INR 0"}
                        </p>
                        <p className="text-zinc-500 text-[11px] line-clamp-1 mt-0.5 break-words">
                          {item.description}
                        </p>

                        <button
                          className="bg-red-400 mt-2 hover:bg-red-500 text-white text-[10px] px-3 py-2 rounded-lg font-bold whitespace-nowrap transition-colors"
                          onClick={() => handleCreateLead(item._id)}
                        >
                          Get Details
                        </button>
                      </div>

                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Mobile + Tablet (768–1024): products slider at bottom — outside left panel so it shows when panel is hidden */}
            {products && products.length > 0 && (
              <div className={`lg:hidden absolute left-0 right-0 ${streamMeta?.isLive === false || streamMeta?.stream_type === "recorded" ? "bottom-16" : "bottom-0"} z-1 px-2 pointer-events-none`}>
                <div ref={mobileScrollRef} className="  flex flex-row gap-1.5 overflow-x-auto pb-2 custom-scrollbar">
                  {products.map((item) => (
                    <div
                      key={item._id}
                      className="bg-white rounded-2xl p-2 shadow-2xl flex items-center gap-3 min-w-[240px] max-w-[300px] flex-shrink-0 pointer-events-auto"
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-14 h-14 rounded-xl object-cover flex-shrink-0"
                      />
                      <div className="flex flex-col gap-1 flex-1 min-w-0">
                        <h4 className="text-black font-semibold text-sm truncate">
                          {item?.title}
                        </h4>
                        <p className="text-black text-xs font-semibold">
                          {item.price ? "INR " + item.price : "INR 0"}
                        </p>
                        {(item?.description || "").trim() && (
                          <p className="text-zinc-500 text-[11px] line-clamp-1 mt-0.5 break-words">
                            {item.description}
                          </p>
                        )}
                        <button
                          className="bg-red-400 hover:bg-red-500 text-white text-[11px] px-3 py-2 rounded-lg font-bold whitespace-nowrap transition-colors w-fit mt-1"
                          onClick={() => handleCreateLead(item._id)}
                        >
                          Get Details
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* MOBILE COMMENTS PANEL (full-width bottom overlay) */}
            {showComments && (
              <div className="lg:hidden absolute inset-x-0 bottom-0 top-1/3 bg-black/60 backdrop-blur-md flex flex-col justify-between p-4 pt-3 gap-3 z-40 pointer-events-auto">
                {/* Header */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <img
                      src={sellerMeta?.profile_image || sellerMeta?.store_image || "/images/User.png"}
                      onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                      alt="User"
                      className="w-8 h-8 rounded-full object-cover border border-white/30"
                    />
                    <div className="flex flex-col">
                      <span className="text-white text-sm font-semibold leading-tight">
                        {sellerMeta?.name || "Sarah Miller"}
                      </span>
                      <span className="text-white/70 text-[11px] leading-tight">
                        {sellerMeta?.store_name || "Sarah's Boutique"}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowComments(false)}
                    className="text-white/70 text-xs px-2 py-1 rounded-full bg-white/10"
                  >
                    Close
                  </button>
                </div>

                {/* Messages */}
                <div
                  ref={chatContainerRef}
                  className="flex-1 overflow-y-auto mt-1 mb-2 pr-1 custom-scrollbar flex flex-col gap-2"
                >
                  {(() => {
                    const rawComments =
                      streamMeta?.isLive === false
                        ? (comments.length > 0 ? comments : visiblePastComments)
                        : [...comments, ...privateReplies];
                    const allComments = [...rawComments].sort(
                      (a, b) =>
                        new Date(a.createdAt).getTime() -
                        new Date(b.createdAt).getTime()
                    );

                    if (allComments.length === 0) {
                      return (
                        <div className="flex-1 flex items-center justify-center text-white/40 text-xs italic">
                          {streamMeta?.isLive === false ? "No comments for this stream" : "Be the first to comment..."}
                        </div>
                      );
                    }

                    return allComments.map((msg, index) => {
                      const msgSenderId = msg.sender?._id || msg.senderID || msg.senderId;
                      const isOwn = msgSenderId?.toString() === userID?.toString();

                      if (msg.isPrivateReply) {
                        return (
                          <div
                            key={`mpr-${index}`}
                            className="flex items-start gap-2 mt-1 break-inside-avoid"
                          >
                            <AvatarImage
                              src={msg.sender?.is_profile_public === false ? null : msg.sender?.profile_image}
                              name={msg.sender?.name || "Streamer"}
                              alt="streamer"
                              className="w-7 h-7 rounded-full object-cover shrink-0 ring-1 ring-yellow-400"
                              style={{ width: "28px", height: "28px", fontSize: "11px" }}
                            />
                            <div className="flex flex-col flex-1 min-w-0">
                              {msg.replyToMessage && (
                                <div className="bg-white/10 border-l-2 border-yellow-400 px-2 py-1 mb-1 rounded text-[10px] text-white/70 flex items-start gap-1">
                                  <CornerDownRight
                                    size={9}
                                    className="mt-0.5 shrink-0 opacity-60"
                                  />
                                  <span className="truncate">{msg.replyToMessage}</span>
                                </div>
                              )}
                              <span className="text-white font-medium text-xs">
                                {isOwn ? "You" : (msg.sender?.is_profile_public === false ? (msg.sender?.name?.charAt(0)?.toUpperCase() || "U") : (msg.sender?.name || "Viewer"))}
                              </span>
                              <span className="text-white/90 text-[11px] break-words whitespace-pre-wrap">
                                {msg.message}
                              </span>
                              <span className="text-yellow-400 text-[9px] font-bold mt-0.5">
                                Private reply
                              </span>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div
                          key={`mc-${index}`}
                          className="flex items-start gap-2 break-inside-avoid"
                        >
                          <AvatarImage
                            src={msg.sender?.is_profile_public === false ? null : msg.sender?.profile_image}
                            name={msg.sender?.name || "Viewer"}
                            alt="avatar"
                            className="w-7 h-7 rounded-full object-cover shrink-0 border border-white/10"
                            style={{ width: "28px", height: "28px", fontSize: "11px" }}
                          />
                          <div className="flex flex-col flex-1 min-w-0">
                            {msg.replyToMessage && (
                              <div className="bg-white/10 border-l-2 border-primary-400 px-2 py-1 mb-1 rounded text-[10px] text-white/70 flex items-start gap-1">
                                <CornerDownRight
                                  size={9}
                                  className="mt-0.5 shrink-0 opacity-60"
                                />
                                <span className="truncate">{msg.replyToMessage}</span>
                              </div>
                            )}
                            <span className="text-white font-medium text-xs">
                              {isOwn ? "You" : (msg.sender?.is_profile_public === false ? (msg.sender?.name?.charAt(0)?.toUpperCase() || "U") : (msg.sender?.name || "Viewer"))}
                            </span>
                            <span className="text-white/80 text-[11px] leading-relaxed break-words whitespace-pre-wrap">
                              {msg.message}
                            </span>
                          </div>
                          {!isOwn && (
                            <button
                              onClick={() =>
                                setReplyTarget({
                                  commentId: msg._id,
                                  senderId: msgSenderId,
                                  senderName: msg.sender?.name || "Viewer",
                                  message: msg.message,
                                })
                              }
                              className="text-[9px] text-primary-400 font-bold uppercase tracking-tight ml-auto pt-1"
                            >
                              reply
                            </button>
                          )}
                        </div>
                      );
                    });
                  })()}
                </div>

                {/* Input */}
                {(isViewing || (streamMeta?.isLive && streamMeta?.stream_type === "recorded") || streamMeta?.isLive === false || streamMeta?.isStreamCompleted || !streamMeta?.isLive) && (
                  <div className="flex flex-col gap-2">
                    {replyTarget && (
                      <div className="bg-white/10 backdrop-blur-md rounded-lg p-2 flex items-start gap-2 border border-white/10">
                        <div className="flex-1 min-w-0">
                          <p className="text-[9px] text-primary-400 font-bold flex items-center gap-1 uppercase tracking-wider mb-0.5">
                            <CornerDownRight size={9} /> Replying to {replyTarget.senderName}
                          </p>
                          <p className="text-[10px] text-white/60 truncate italic">"{replyTarget.message}"</p>
                        </div>
                        <button
                          onClick={() => setReplyTarget(null)}
                          className="text-white/40"
                        >
                          <RotateCcw size={12} className="rotate-45" />
                        </button>
                      </div>
                    )}
                    <div className="flex items-center gap-2">
                      <input
                        type="text"
                        placeholder={replyTarget ? `Reply to ${replyTarget.senderName}...` : "Write here..."}
                        className="flex-1 bg-white/10 backdrop-blur-md text-white placeholder-white/40 border border-white/20 h-[42px] rounded-full px-4 text-xs outline-none"
                        value={replyTarget ? replyMessage : inputMessage}
                        onChange={(e) => replyTarget ? setReplyMessage(e.target.value) : setInputMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && (replyTarget ? handleSendReply() : handleSend())}
                      />
                      <button
                        onClick={replyTarget ? handleSendReply : handleSend}
                        className="bg-primary-500 w-[42px] h-[42px] rounded-full text-white flex items-center justify-center shrink-0"
                      >
                        <Send size={18} className="ml-0.5" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {liveCaption && (
              <div
                style={{
                  position: "absolute",
                  top: window.innerWidth <= 768 ? "12%" : "8%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  maxWidth: "100%",
                  padding: "14px 14px",
                  background: "rgba(0,0,0,0.65)",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "16px",
                  textAlign: "center",
                  pointerEvents: "none",
                  lineHeight: "1.4",
                  zIndex: 20,
                  overflowWrap: "break-word",
                  wordBreak: "break-word"
                }}>
                {liveCaption}
              </div>
            )}

            {/* RIGHT SIDE PANEL (Glassmorphism & Toggle) - desktop/tablet only */}
            {showComments && (
              <div className="hidden lg:flex max-w-[100%] h-auto lg:max-w-[400px] flex-col gap-4 justify-between bg-black/40 w-full p-[20px] rounded-[20px] pointer-events-auto">
                <div className="flex flex-col gap-4 flex-1 min-h-0">

                  {/* Streamer Profile Pill */}
                  <div className="bg-white/5 backdrop-blur-md rounded-2xl p-[12px] flex items-center gap-3">
                    <img 
                      src={sellerMeta?.profile_image || sellerMeta?.store_image || "/images/User.png"} 
                      onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                      alt="User" 
                      className="w-[50px] h-[50px] shrink-0 rounded-full object-cover border border-white/20" 
                    />
                    <div className="min-w-0 flex-1">
                      <h4 className="text-white text-[14px] font-bold truncate leading-tight">{sellerMeta?.name || "Sarah Miller"}</h4>
                      <span className="text-white/70 text-[11px] truncate">{sellerMeta?.store_name || "Sarah's Boutique"}</span>

                    </div>
                    <div className="shrink-0 ml-auto">
                      <button
                        onClick={() => {
                          stopViewing();
                          navigate("/user/live-streams");
                        }}
                        className="btn btn-pri">
                        Leave
                      </button>
                    </div>
                  </div>

                  {/* Chat Messages */}
                  <div
                    ref={chatContainerRef}
                    className="flex-1 overflow-y-auto pr-2 custom-scrollbar flex flex-col gap-2 my-2 min-h-0"
                  >
                    {/* Merge comments based on live state */}
                    {(() => {
                      const rawComments =
                        streamMeta?.isLive === false
                          ? (comments.length > 0 ? comments : visiblePastComments)
                          : [...comments, ...privateReplies];

                      // Sort by creation date
                      const allComments = [...rawComments].sort(
                        (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                      );

                      if (allComments.length === 0) {
                        return (
                          <div className="flex-1 flex items-center justify-center text-white/40 text-sm italic">
                            {streamMeta?.isLive === false ? "No comments for this stream" : "Be the first to comment..."}
                          </div>
                        );
                      }

                      return allComments.map((msg, index) => {
                        const msgSenderId = msg.sender?._id || msg.senderID || msg.senderId;
                        const isOwn = msgSenderId?.toString() === userID?.toString();
                        const isPrivate = msg.isPrivateReply;

                        if (isPrivate) {
                          return (
                            <div key={`mpr-dt-${index}`} className="flex items-start gap-2 mt-2 break-inside-avoid">
                              <AvatarImage
                                src={msg.sender?.is_profile_public === false ? null : msg.sender?.profile_image}
                                name={msg.sender?.name || "Streamer"}
                                alt="streamer"
                                className="w-8 h-8 rounded-full object-cover shrink-0 ring-1 ring-yellow-400"
                                style={{ width: "32px", height: "32px", fontSize: "13px" }}
                              />
                              <div className="flex flex-col flex-1 min-w-0">
                                {msg.replyToMessage && (
                                  <div className="bg-white/10 border-l-2 border-yellow-400 px-2 py-1 mb-1 rounded text-[11px] text-white/70 flex items-start gap-1">
                                    <CornerDownRight size={10} className="mt-0.5 shrink-0 opacity-60" />
                                    <span className="truncate">{msg.replyToMessage}</span>
                                  </div>
                                )}
                                <span className="text-white font-medium text-sm">
                                  {isOwn ? "You" : (msg.sender?.is_profile_public === false ? (msg.sender?.name?.charAt(0)?.toUpperCase() || "U") : (msg.sender?.name || "Viewer"))}
                                </span>
                                <span className="text-white/90 text-[12px] break-words whitespace-pre-wrap leading-relaxed">
                                  {msg.message}
                                </span>
                                <span className="text-yellow-400 text-[10px] font-bold mt-0.5">
                                  Private reply
                                </span>
                              </div>
                            </div>
                          );
                        }

                        return (
                          <div
                            key={`c-${index}`}
                            className="flex items-start gap-2 break-inside-avoid group relative"
                          >
                            <AvatarImage
                              src={msg.sender?.is_profile_public === false ? null : msg.sender?.profile_image}
                              name={msg.sender?.name || "Viewer"}
                              alt="avatar"
                              className="w-8 h-8 rounded-full object-cover shrink-0 border border-white/10"
                              style={{ width: "32px", height: "32px", fontSize: "13px" }}
                            />

                            <div className="flex flex-col flex-1 min-w-0">
                              {msg.replyToMessage && (
                                <div className="bg-white/10 border-l-2 border-primary-400 px-2 py-1 mb-1 rounded text-[11px] text-white/70 flex items-start gap-1">
                                  <CornerDownRight size={10} className="mt-0.5 shrink-0 opacity-60" />
                                  <span className="truncate">{msg.replyToMessage}</span>
                                </div>
                              )}
                              <span className="text-white font-medium text-sm">
                                {isOwn ? "You" : (msg.sender?.is_profile_public === false ? (msg.sender?.name?.charAt(0)?.toUpperCase() || "U") : (msg.sender?.name || "Viewer"))}
                              </span>

                              <span className="text-white/80 text-[12px] leading-relaxed break-words whitespace-pre-wrap">
                                {msg.message}
                              </span>
                            </div>

                            {/* Reply Button for others' messages */}
                            {!isOwn && (
                              <button
                                onClick={() =>
                                  setReplyTarget({
                                    commentId: msg._id,
                                    senderId: msgSenderId,
                                    senderName: msg.sender?.name || "Viewer",
                                    message: msg.message,
                                  })
                                }
                                className="text-[10px] text-primary-400 font-bold opacity-0 group-hover:opacity-100 transition-opacity uppercase tracking-tight hover:underline whitespace-nowrap"
                              >
                                reply
                              </button>
                            )}
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>

                {/* Chat Input */}
                {(isViewing || (streamMeta?.isLive && streamMeta?.stream_type === "recorded") || streamMeta?.isLive === false || streamMeta?.isStreamCompleted || !streamMeta?.isLive) && (
                  <div className="flex flex-col gap-2 mt-2">
                    {/* Reply Target UI */}
                    {replyTarget && (
                      <div className="bg-white/10 backdrop-blur-md rounded-lg p-2 flex items-start gap-2 animate-in slide-in-from-bottom-2 duration-200 border border-white/10 mb-1">
                        <div className="flex-1 min-w-0">
                          <p className="text-[10px] text-primary-400 font-bold flex items-center gap-1 uppercase tracking-wider mb-0.5">
                            <CornerDownRight size={10} /> Replying to {replyTarget.senderName}
                          </p>
                          <p className="text-[11px] text-white/60 truncate italic">"{replyTarget.message}"</p>
                        </div>
                        <button
                          onClick={() => setReplyTarget(null)}
                          className="text-white/40 hover:text-white transition-colors"
                        >
                          <RotateCcw size={14} className="rotate-45" />
                        </button>
                      </div>
                    )}

                    <div className="flex items-center gap-2">
                      <input
                        type="text"
                        placeholder={replyTarget ? `Reply to ${replyTarget.senderName}...` : "Write here..."}
                        className="flex-1 w-full bg-white/10 backdrop-blur-md text-white placeholder-white/40 border border-white/20 h-[48px] rounded-full px-5 text-sm transition-all focus:bg-white/20 outline-none"
                        value={replyTarget ? replyMessage : inputMessage}
                        onChange={(e) => replyTarget ? setReplyMessage(e.target.value) : setInputMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && (replyTarget ? handleSendReply() : handleSend())}
                      />
                      <button
                        onClick={replyTarget ? handleSendReply : handleSend}
                        className="bg-primary-500 w-[48px] h-[48px] rounded-full text-white flex items-center justify-center shrink-0 shadow-lg transition-all hover:scale-110 active:scale-95 hover:bg-primary-600"
                      >
                        <Send size={20} className="ml-0.5" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        stream={streamMeta}
        type="stream"
        customTitle={streamMeta?.stream_title || streamMeta?.title || (sellerMeta?.store_name ? `${sellerMeta.store_name}'s Live Stream` : "Live Stream")}
        shareUrl={window.location.href}
      />
    </div>
  );
}

export default LiveStreamDetail;
